<template>
  <div class="shareBtn">
    <ul class="shareBtn--list">
      <li class="shareBtn--list__li" @click="onGetTop">
        <img src="@/assets/imgs/getTotop.png" alt="">
      </li>
      <li class="shareBtn--list__li">
        <img src="@/assets/imgs/phone.png" alt="">
        <div class="hoverCont"><p>{{contactWays.phone}}</p></div>
      </li>
      <li class="shareBtn--list__li">
        <img src="@/assets/imgs/qq.png" alt="">
        <div class="hoverCont"><p>{{contactWays.qq}}</p></div>
      </li>
      <li class="shareBtn--list__li">
        <img src="@/assets/imgs/codeShare.png" alt="">
        <div class="codeImg">
          <img :src="'http://admin.origination.cn/'+contactWays.wx_img" alt="">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name:'ShareBtn',
  data(){
    return{
      contactWays:{},     //联系方式
    }
  },
  methods:{
    // 返回顶部和分享
    onGetTop(){
      //返回顶部
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    onSharenBtn(){
      this.$post('api/index/index/side').then(res => {
        // console.log(res)
        if (res.code==1) {
          this.contactWays = res.data.contact
        } else {
          alert(res.msg)
        }
      }).catch(err => {
        alert(err)
      })
    },
  },
  created(){
    this.onSharenBtn()
  }
}
</script>
<style lang="less" scoped>
.shareBtn{
  font-size: calc(100vw / 19.2)!important;
  .shareBtn--list{
    display: flex;
    flex-direction: column;
    li{
      width: .44em;
      height: .44em;
      line-height: 0;
      margin-bottom: .05em;
      position: relative;
      >img{
        width: 100%;
        height: 100%;
      }
      .hoverCont{
        display: none;
        position: absolute;
        left: 38px;
        top: 0;
        font-size: .16em;
        color: #777777;
        text-align: center;
        >p{
          width: 120px;
          background: #eeeeef;
          height: 2.8em;
          line-height: 2.8em;
          border-radius: 0 .5em .5em 0;
        }
      }
      .codeImg{
        display: none;
        position: absolute;
        top: .1em;
        left: .46em;
        right: 0;
        width: 1em;
        height: auto;
        img{
          width: 100%;
          height: 100%;
        }
      }
      &:hover{
        .hoverCont{
          display: block;
        }
        .codeImg{
          display: block;
        }
      }
    }
  }
}
// 手机端,ipad
@media screen and (max-width: 1040px){
  .shareBtn--list{
    li{
      width:.7rem !important;
      height: .71rem !important;
      }
      .hoverCont{
        left: -1.52rem !important;
        font-size: .15rem !important;
        color: #777777;
        >p{
          width: 1.7rem !important;
          height: .7rem !important;
          line-height: .7rem !important;
          border-radius: .12rem 0 0 .12rem !important;
        }
      }
      .codeImg{
        position: absolute;
        top: 10px;
        left: -1.1rem !important;
        width: 1rem !important;
        
      }
      &:hover{
        .hoverCont{
          display: block;
        }
        .codeImg{
          display: block;
        }
      }
    }
  
}
</style>


// WEBPACK FOOTER //
// src/components/shareBtn.vue